export default __webpack_public_path__ + "static/DettolSansWeb-SemiBold-a5c83dd59c59047d1eb538b6fcfc4e9a.woff2";